//@ts-ignore @eslint-ignore
//ONLY WORKS FOR 1:1 MAPPINGS OF KEY:VALUE
export const getKeyByValue = (object, value) => {
    //@ts-ignore @eslint-ignore
    return Object.keys(object).find((key) => object[key] === value);
};
export const isFunction = (value) => checkTypeOf(value, "function");
export const isObject = (value) => checkTypeOf(value, "object");
export const checkTypeOf = (value, type) => typeof value === type;
export const areObjectsEqual = (obj1, obj2) => {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
};
export const removeNullFields = (obj) => Object.entries(obj)
    .filter(([_, v]) => v != null)
    .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});
export const checkAllFalseAndSetFirstTrue = (map) => {
    const keys = Object.keys(map);
    if (keys.length === 0) {
        return map;
    }
    const values = Object.values(map);
    const allFalse = values.every((value) => !value);
    if (allFalse) {
        map[keys[0]] = true;
    }
    return map;
};
//# sourceMappingURL=ObjectUtil.js.map